/// <reference path="WebService.ts" />


interface WebService
{
    downloadSyncLogFile( syncID:string, target:any, completion:any ) : void;
    uploadSyncLogfile( syncLog:SyncLog, content: string, target:any, completion:any ) : void;
    uploadDocument( entityName:string, entityID:string, file:File, completion:any ) : void;
    uploadInvoiceFile( invoice:Invoice, file:File, completion:any ) : void;
    uploadSupplierNoteFile( stockNote:StockNote, file:File, completion:any ) : void;
    scanInvoiceByOCR( invoice:Invoice, completion:any ) : void;
    runDocumentExtraction( entityName:string, entityID:string, completion:any ) : void;
    documentExtractionStatus( entityName:string, entityID:string, completion:any ) : void;
    documentExtractionMatch( entityName:string, entityID:string, completion:any ) : void;
    postDocumentExtractionReview( entityName:string, entityID:string, outcome:any, completion:any ) : void;
    postDocumentExtractionOptions( entityName:string, entityID:string, options:any, completion:any ) : void;
}

WebService.prototype.downloadSyncLogFile = function( syncID:string, target:any, completion:any ){
    const url = MIOURL.urlWithString(this.apiURL + "/schema/" + this.scheme + "/get-file/" + syncID );        
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, null, "GET");
    urlRequest.execute(target, completion);        
}

WebService.prototype.uploadSyncLogfile = function( syncLog:SyncLog, content: string, target:any, completion:any ) {
    const url = MIOURL.urlWithString(this.apiURL + "/schema/" + this.scheme + "/replace-file/" + syncLog.identifier );
    let urlRequest = new MWSRequest();        
    urlRequest.initWithURL(url, content, "POST");
    urlRequest.setHeaderValue("application/json", "Content-Type");
    urlRequest.setHeaderValue(syncLog.appID, "DL-APP-ID");
    // urlRequest.setHeaderValue(syncLog.placeID, "DL-PLACE-ID");
    urlRequest.execute(target, completion);
}

WebService.prototype.uploadDocument = function( entityName:string, entityID:string, file:File, completion:any ) {
    let filename_base64 = window.btoa(file.name).replace(/=/g, ''); // remove padding
    let cmd = new WebServiceCommand(this.fileURL, "/" + this.scheme + "/upload-document/" + entityName + "/" + entityID + "/" + filename_base64);
    cmd.method = "PUT";
    cmd.blobData = file;

    cmd.execute(this, function (code:number, data:any) {
        if (completion != null) completion(code, data);
    });
}

WebService.prototype.uploadInvoiceFile = function( invoice:Invoice, file:File, completion:any ) {
    this.uploadDocument(invoice.entity.name, invoice.identifier, file, completion);
}

WebService.prototype.uploadSupplierNoteFile = function( stockNote:StockNote, file:File, completion:any ) {
    this.uploadDocument(stockNote.entity.name, stockNote.identifier, file, completion);
}

// Document extraction lives in DLInsightsBotServer (the cluster's AI server). The deprecated Cloud Levante
// endpoint on the integrator is no longer called.
WebService.prototype.scanInvoiceByOCR = function( invoice:Invoice, completion:any ) {
    this.runDocumentExtraction( invoice.entity.name, invoice.identifier, completion );
}

// The server answers { status, data }: the callers of the extraction calls get the data.
function documentExtractionAnswer( json:any ) : any {
    return json != null && json["data"] !== undefined ? json["data"] : json;
}

WebService.prototype.runDocumentExtraction = function( entityName:string, entityID:string, completion:any ) {
    let cmd = new WebServiceCommand(this.insightsURL, "/schema/" + this.scheme + "/document-extraction/run/" + entityName + "/" + entityID);
    cmd.method = "GET";
    cmd.execute(this, function (code:number, json:any) {
        if (completion != null) completion(code, documentExtractionAnswer(json));
    });
}

WebService.prototype.documentExtractionStatus = function( entityName:string, entityID:string, completion:any ) {
    let cmd = new WebServiceCommand(this.insightsURL, "/schema/" + this.scheme + "/document-extraction/status/" + entityName + "/" + entityID);
    cmd.method = "GET";
    cmd.execute(this, function (code:number, json:any) {
        if (completion != null) completion(code, documentExtractionAnswer(json));
    });
}

// Phase 2: re-run the matcher on the stored extraction (no engine call); returns the proposal.
WebService.prototype.documentExtractionMatch = function( entityName:string, entityID:string, completion:any ) {
    let cmd = new WebServiceCommand(this.insightsURL, "/schema/" + this.scheme + "/document-extraction/match/" + entityName + "/" + entityID);
    cmd.method = "GET";
    cmd.execute(this, function (code:number, json:any) { if (completion != null) completion(code, documentExtractionAnswer(json)); });
}

// Phase 3: the review outcome { by, supplierID, changed, corrections[], picks[], applied }.
// The server learns the picks (aliases, supplier products), flags corrected values for IT
// review and re-matches; the response carries the updated record.
WebService.prototype.postDocumentExtractionReview = function( entityName:string, entityID:string, outcome:any, completion:any ) {
    let cmd = new WebServiceCommand(this.insightsURL, "/schema/" + this.scheme + "/document-extraction/review/" + entityName + "/" + entityID);
    cmd.method = "POST";
    cmd.params = outcome;
    cmd.execute(this, function (code:number, json:any) { if (completion != null) completion(code, documentExtractionAnswer(json)); });
}

// The extraction options of the document's legal entity ({ pricesIncludeTax, groupLines,
// groupLinesConceptID }, the ones given are written); the answer carries the options and the
// reading re-derived with them.
WebService.prototype.postDocumentExtractionOptions = function( entityName:string, entityID:string, options:any, completion:any ) {
    let cmd = new WebServiceCommand(this.insightsURL, "/schema/" + this.scheme + "/document-extraction/options/" + entityName + "/" + entityID);
    cmd.method = "POST";
    cmd.params = options;
    cmd.execute(this, function (code:number, json:any) { if (completion != null) completion(code, documentExtractionAnswer(json)); });
}
